import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import styled from "styled-components";
import api from "../../../../Component/axios_Interceptor/api";
import {
  Optionbox,
  product_option,
} from "../../../../Component/Interface/Live";
import url from "../../../../Component/server";
import { fontStyles } from "../../../../Component/style/common_font";
import {
  BackgroundArea,
  Icon,
  RowView,
  RowView2,
} from "../../../../Component/style/common_style";
import OptionBox_list from "./OptionBox_list";
import OptionBox_tags from "./OptionBox_tags";
import { StoreInfo } from "../../../../Component/Interface/Store";

const OptionBox = forwardRef(
  ({ updateChnage }: { updateChnage: () => void }, ref) => {
    const [product_seq, setProduct_seq] = useState<number>(0);
    const [live_seq, setLive_seq] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [isOn, setIsOn] = useState(false);
    const [product_status, setProduct_status] = useState("");
    const isNotModi = product_status !== "대기";
    const [store_info, setStore_info] = useState<StoreInfo>();

    useImperativeHandle(ref, () => ({ setData }));

    const setData = (data: {
      yn: boolean;
      seq: number;
      product_status: string;
      live_seq: number;
      store_info: StoreInfo;
    }) => {
      setIsOn(data.yn);
      setProduct_seq(data.seq);
      setProduct_status(data.product_status);
      setIsOpen(true);
      setLive_seq(data.live_seq);
      setStore_info(data.store_info);
    };

    const closeModal = () => {
      setIsOpen(false);
      // 초기화
      setIsOn(false);
      setProduct_seq(0);
      setProduct_status("");
      setSearch_option_name("");
      setSelectlist1([]);
      setSelectlist2([]);
      setSelectOptions([]);
    };

    const [optionBox1, setOptionBox1] = useState<Optionbox[]>([]);
    const [optionBox2, setOptionBox2] = useState<Optionbox[]>([]);
    const [search_option_num, setSearch_option_num] = useState(1);
    const [search_option_name, setSearch_option_name] = useState("");

    const setting_option_num = (e: React.ChangeEvent<HTMLSelectElement>) =>
      setSearch_option_num(Number(e.target.value));
    const setting_option_name = (e: React.ChangeEvent<HTMLInputElement>) =>
      setSearch_option_name(e.target.value);

    const setting_toggleOn = async () => {
      if (isNotModi) {
        alert("판매/판매노출 상품의 상태는 수정할 수 없습니다.");
        return;
      }
      try {
        const res = await api.patch(
          url.Communication_url.product_option_enable,

          {
            seq: product_seq,
            live_seq: live_seq,
            option_check: isOn ? "n" : "y",
          },

          { headers: { "Content-Type": "application/json" } }
        );

        if (res.data === "성공") {
          updateChnage();
          if (isOn) return setIsOn(false);
          return setIsOn(true);
        } else {
          alert("재고가 있는 상품은 옵션을 설정할 수 없습니다.");
        }
      } catch (error) {
        console.error("데이터 로드 실패:", error);
        if (
          (error as any)?.response?.data.message ===
          "재고가 있는 상품은 변경이 불가능합니다."
        ) {
          alert("재고가 있는 상품은 옵션을 설정할 수 없습니다.");
        }
      }
    };

    const load_option_tag_all = async () => {
      try {
        const res = await api.get(url.Communication_url.option_tag_list, {
          params: { store_seq: store_info?.seq },
        });
        const data = res.data || [];

        setOptionBox1(data.option1);
        setOptionBox2(data.option2);
      } catch (error) {
        console.error("데이터 로드 실패:", error);
      }
    };
    useEffect(() => {
      if (store_info) {
        load_option_tag_all();
      }
    }, [store_info]);

    const search_option_tag = async () => {
      try {
        const res = await api.get(url.Communication_url.search_option_tag, {
          params: {
            option_num: search_option_num,
            option_name: search_option_name,
          },
        });
        const data = res.data.option_tag_list || [];
        if (search_option_num === 1) {
          setOptionBox1(data || []);
        } else {
          setOptionBox2(data || []);
        }
      } catch (error) {
        console.error("데이터 로드 실패:", error);
      }
    };
    const search_reset = async () => {
      setSearch_option_name("");
      load_option_tag_all();
    };

    const insert_tag: (num: number, name: string) => Promise<boolean> = async (
      num: number,
      name: string
    ) => {
      try {
        const res = await api.post(url.Communication_url.option_tag_create, {
          option_num: num,
          option_name: name,
        });

        if (res.data === "성공") {
          alert("추가되었습니다.");
          load_option_tag_all(); // reload
          return true;
        }
        if (res.data === "중복") {
          alert("해당 태그가 이미 존재합니다.");
        }
        return false;
      } catch (error) {
        console.error("데이터 로드 실패:", error);
        return false;
      }
    };

    const delet_tag = async (optionNum: number, tag_seq: number) => {
      if (!window.confirm("해당 옵션을 정말로 삭제하시겠습니까?")) {
        return;
      }
      const settingBox = optionNum === 1 ? setOptionBox1 : setOptionBox2;
      const optionBox = optionNum === 1 ? optionBox1 : optionBox2;

      try {
        const res = await api.delete(url.Communication_url.option_tag_delete, {
          data: { seq: tag_seq },
        });

        if (res.data === "성공") {
          alert("삭제되었습니다.");
          settingBox(
            optionBox.filter((item: Optionbox) => item.seq !== tag_seq) || []
          );
        }
      } catch (error) {
        console.error("데이터 로드 실패:", error);
      }
    };

    /** 옵션 선택 - 선택적용하기 */
    const [selectlist1, setSelectlist1] = useState<string[]>([]);
    const [selectlist2, setSelectlist2] = useState<string[]>([]);
    const [selectOptions, setSelectOptions] = useState<product_option[]>([]);

    const select_tag = (optionNum: number, name: string) => {
      if (optionNum !== 1 && selectlist1.length === 0) {
        alert("옵션1을 선택해주세요.");
        return;
      }
      const selectlist = optionNum === 1 ? selectlist1 : selectlist2;
      const setSelectlist = optionNum === 1 ? setSelectlist1 : setSelectlist2;

      if (selectlist.includes(name)) {
        setSelectlist(selectlist.filter((item) => item !== name));
        // 옵션 1선택을 모두 해제 시 옵션2 초기화
        if (optionNum === 1 && selectlist.length === 1) setSelectlist2([]);
      } else {
        setSelectlist([...selectlist, name]);
      }
    };

    const settiing_list3 = () => {
      if (selectlist1.length === 0) {
        return setSelectOptions([]);
      }
      const selectlist3 = selectlist1.flatMap((item1) =>
        selectlist2.length === 0
          ? [{ option1: item1, option2: "", init_cnt: 0 }]
          : selectlist2.map((item2) => ({
              option1: item1,
              option2: item2,
              init_cnt: 0,
            }))
      );
      setSelectOptions(selectlist3);
    };
    useEffect(() => {
      settiing_list3();
    }, [selectlist1, selectlist2]);

    // 선택 적용하기
    const productOptionListRef = useRef<{
      get_product_option_info: () => void;
    } | null>(null);

    const option_apply = async () => {
      if (isNotModi) {
        alert("판매/판매노출 상품의 상태는 수정할 수 없습니다.");
        return;
      }
      if (selectOptions.length === 0) {
        return;
      }
      try {
        const res = await api.post(
          url.Communication_url.product_option_save,
          {
            product_seq: product_seq,
            option_list: selectOptions,
          },
          { headers: { "Content-Type": "application/json" } }
        );
        // console.log(res.data);
        if (res.data === "성공") {
          setSelectlist1([]);
          setSelectlist2([]);
          setSelectOptions([]);
          updateChnage(); // 상품 list reload
          if (productOptionListRef.current) {
            // 상품 옵션 list reload
            productOptionListRef.current.get_product_option_info();
          }
        }
      } catch (error) {
        console.error("데이터 로드 실패:", error);
      }
    };

    return (
      <BackgroundArea style={isOpen ? {} : { display: "none" }}>
        <ModalBox className={isOn ? "on" : "off"}>
          <TitleArea>
            <RowView2>
              <div>옵션 설정</div>
              <ToggleArea onClick={setting_toggleOn} $isToggleOn={isOn}>
                <div className="background">
                  <div className="btn" />
                </div>
              </ToggleArea>
            </RowView2>

            <Icon
              src={require("../../../../Image/ic_closeX.png")}
              onClick={closeModal}
            />
          </TitleArea>

          {isOn && (
            <ConBox>
              <section style={{ marginRight: "2rem" }}>
                <RowView2 className="tags">
                  <div style={{ flex: 1, marginRight: "0.5rem" }}>
                    <div className="title">옵션1</div>
                    <OptionBox_tags
                      optionNum={1}
                      optionList={optionBox1}
                      selectList={selectlist1}
                      insert_tag={insert_tag}
                      delet_tag={delet_tag}
                      select_tag={select_tag}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <div className="title">옵션2</div>
                    <OptionBox_tags
                      optionNum={2}
                      optionList={optionBox2}
                      selectList={selectlist2}
                      insert_tag={insert_tag}
                      delet_tag={delet_tag}
                      select_tag={select_tag}
                    />
                  </div>
                </RowView2>

                <InsertOption>
                  <select
                    value={search_option_num}
                    onChange={setting_option_num}
                  >
                    <option value={1}>옵션1</option>
                    <option value={2}>옵션2</option>
                  </select>
                  <input
                    style={{ flex: 1, marginLeft: "0.5rem" }}
                    placeholder="찾고자하는 옵션을 입력해주세요."
                    value={search_option_name}
                    onChange={setting_option_name}
                  />
                  <span onClick={search_option_tag}>찾기</span>
                  <Icon
                    src={require("../../../../Image/ic_reset_black.png")}
                    onClick={search_reset}
                  />
                </InsertOption>

                <SelectOption>
                  <RowView>
                    <div className="title">선택한 옵션</div>
                    <div className="btn" onClick={option_apply}>
                      선택 적용하기
                    </div>
                  </RowView>

                  <Options className="wrap top">
                    {selectOptions.map((list, idx) => {
                      return (
                        <div key={idx}>{`${list.option1}/${list.option2}`}</div>
                      );
                    })}
                  </Options>
                </SelectOption>
              </section>

              <section>
                <div className="title">옵션 적용</div>
                <OptionBox_list
                  ref={productOptionListRef}
                  isNotModi={isNotModi}
                  isOpen={isOpen}
                  product_seq={product_seq}
                  updateChnage={updateChnage}
                />
              </section>
            </ConBox>
          )}
        </ModalBox>
      </BackgroundArea>
    );
  }
);

export default OptionBox;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  margin: auto 1rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  padding: 1.5rem;
  &.off {
    max-width: 20rem;
    height: 10rem;
  }
  &.on {
    max-width: 70rem;
  }
`;
const TitleArea = styled(RowView)`
  margin-bottom: 2rem;
  div {
    ${fontStyles.medium}
    font-size: 20px;
  }
  img {
    cursor: pointer;
  }
`;
const ToggleArea = styled.div<{ $isToggleOn: boolean }>`
  display: flex;
  align-items: center;
  margin-left: 0.5rem;
  cursor: pointer;
  div.background {
    position: relative;
    width: 2.8rem;
    height: 1.8rem;
    border-radius: 8px;
    outline: none;
    padding: 0 2px;
    transition: all 0.3s;
    ${(props) =>
      props.$isToggleOn
        ? "background: linear-gradient(to bottom right, #ec7a58, #ea2922)"
        : "background-color: #F8F8F8"};
  }
  div.btn {
    width: 1.4rem;
    height: 1.4rem;
    margin-top: 0.2rem;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 0px 5px #7c7c7c9c;
    transition: all 0.3s;
    transform: ${(props) =>
      props.$isToggleOn ? "translateX(22px)" : "translateX(0px)"};
  }
`;
const ConBox = styled(RowView)`
  align-items: flex-start;
  section {
    flex: 1;
    width: 100%;
    overflow: hidden;
  }
  div.title {
    ${fontStyles.semiBold}
  }
  div.stock {
    width: 5rem;
  }
  @media ${({ theme }) => theme.modal} {
    flex-direction: column;
  }
`;
const InsertOption = styled(RowView)`
  margin: 0.5rem 0;
  select,
  input {
    padding: 0.8rem 1rem;
    font-size: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    &:hover,
    &:focus {
      border: 1px solid #454545;
    }
  }
  span {
    padding: 0.8rem 1.5rem;
    margin-left: 0.5rem;
    white-space: nowrap;
    ${fontStyles.semiBold}
    color: #2d2d2d;
    background-color: white;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    cursor: pointer;
  }
  img {
    padding: 0.5rem;
    margin-left: 0.5rem;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    cursor: pointer;
  }
`;
const SelectOption = styled.div`
  border: 1px solid #f0f0f0;
  padding: 1rem;
  padding-bottom: 0;
  border-radius: 8px;
  div.btn {
    padding: 0.5rem 1rem;
    ${fontStyles.medium}
    color: white;
    background: linear-gradient(135deg, #7955f0, #3209b9);
    border-radius: 4px;
    cursor: pointer;
  }
`;
const Options = styled(RowView2)`
  height: 8rem;
  margin-top: 1rem;
  overflow: auto;
  overflow-x: hidden;
  div {
    padding: 0.4rem 0.8rem;
    margin-right: 0.5rem;
    margin-bottom: 1rem;
    font-size: 14px;
    border: 1px solid #f0f0f0;
    border-radius: 50px;
  }
`;
